import { useCallback } from 'react';

import { useAnalytics } from '@bonusly/who-am-i';

import { useContextualizedBonusDetails } from '../../../hooks/use-contextualized-bonus-details';
import { getCelebrationType } from '../../../utils';
import { useReactionContext } from '../reaction-select-context';

enum Action {
	Create = 'Create',
	Remove = 'Delete',
	Replace = 'Replace',
}

export const useTrackReaction = () => {
	const { bonus } = useReactionContext();
	const { isCreatedByUser, isUserReceiver } = useContextualizedBonusDetails(bonus);
	const { track } = useAnalytics();

	const sendEvent = useCallback(
		(action: Action, type: string) => {
			track(`Monarch Bonus Feed Reaction ${action} Action`, {
				celebrationType: getCelebrationType(bonus),
				isUserGiver: isCreatedByUser,
				isUserReceiver,
				reactionType: type,
			});
		},
		[isCreatedByUser, isUserReceiver, track]
	);

	const createTracker = useCallback(
		(action: Action) => {
			return (type: string) => sendEvent(action, type);
		},
		[sendEvent]
	);

	return {
		create: createTracker(Action.Create),
		replace: createTracker(Action.Replace),
		remove: createTracker(Action.Remove),
		quick: () => sendEvent(Action.Create, 'quick-like'),
	};
};
